<template>
  <div class="mb-4">
    <fccTable
      striped
      hover
      responsive
      search
      pagination
      :fields="fields"
      :items="relacoesDosColegios"
      :porPage="itemsPorPage"
      @row-selected="selecionaLinha"
    >
    </fccTable>

    <div class="d-flex flex-row-reverse">
      <fccButton @click="excluir">Excluir</fccButton>
      <fccButton @click="atualizar" class="mr-2">Atualizar</fccButton>
    </div>
  </div>
</template>
<script>
export default {
  props: ['relacoesDosColegios'],
  data() {
    return {
      dadosSelecionados: [],
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: false
        },
        { key: 'codigo', label: 'Código', sortable: true },
        { key: 'idatual', label: 'ID Atual', sortable: true },
        { key: 'idcadastro', label: 'ID Cadastro', sortable: true },
        { key: 'colegioatual', label: 'Colégio Atual', sortable: true },
        { key: 'colegiocadastro', label: 'Colégio Cadastro', sortable: true },
        { key: 'enderecoatual', label: 'Endereço Atual', sortable: true },
        { key: 'enderecocadastro', label: 'Endereço Cadastro', sortable: true },
        { key: 'idcolegio', label: 'ID Colegio', sortable: true }
      ],
      itemsPorPage: 10
    }
  },
  computed: {
    possuiLinhaSelecionada() {
      return this.dadosSelecionados.length > 0
    }
  },
  methods: {
    selecionaLinha(dados) {
      this.dadosSelecionados = dados
    },
    atualizar() {
      const payload = this.dadosSelecionados.map((colegio) => {
        return {
          idDataColegio: colegio.idcolegio,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }
      })

      this.$emit('atualizar', payload)
    },
    excluir() {
      const payload = this.dadosSelecionados.map((colegio) => {
        return {
          idDataColegio: colegio.idcolegio,
          cdFuncionario: this.dadosUserSession.usuCdFuncionario
        }
      })

      this.$emit('excluir', payload)
    }
  }
}
</script>